<template>
    <v-container fluid>
        <v-card >
          <v-card-title>
              Historial de Llamadas
          </v-card-title>
          <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-data-table 
                      :loading="loading" 
                      :items="listaGestiones"
                      v-model="selectedRow"
                      :server-items-length="totalItems"
                      :options.sync="options"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                    <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                        No se encontraron gestiones.
                        </v-alert>
                    </template>
                    <template v-slot:item="{ item }">
                        <tr>
                          <span class="font-weight-light">
                            El dia <span class="font-weight-bold">{{item.fecha | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}} </span> a las <span class="font-weight-bold">{{item.fecha | dateParse('YYYY-MM-DD HH:mm') | dateFormat('HH:mm')}} </span> el Gestor <span class="font-weight-bold">{{item.responsable}}</span>  se llamó al <span class="font-weight-bold">{{item.tipoPersonaContactadaDescripcion}}</span>  <span v-if="item.telefonoContactado" class="font-weight-bold"> al número {{item.telefonoContactado}}</span> <br>
                            Tarea: <span class="font-weight-bold">{{item.tipoGestionDescripcion}}/{{item.tareaDescripcion}} </span>                          
                            Respuesta: <span class="font-weight-bold">{{item.respuestaDescripcion}} </span>
                            <span v-if="item.motivoRechazoDescripcion"> 
                            Motivo Rechazo: <span class="font-weight-bold">{{item.motivoRechazoDescripcion}} </span>
                            </span>       
                            <span v-if="item.fechaPromesa"> 
                              para el <span class="font-weight-bold green white--text" >{{item.fechaPromesa | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}}</span> 
                            </span>
                            <span v-if="item.importePromesa"> 
                              Con un importe de $: <span class="font-weight-bold">{{item.importePromesa}} </span>
                            </span>
                            <br>                            
                            Comentarios : <span class="font-weight-medium">{{item.comentarios}}</span><br>
                            <hr>
                          </span>
                        </tr>
                    </template>
                    </v-data-table>
                  </v-col>
              </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    editMode: true,
    loading: false,
    options: { // definición de paginación
        sortDesc:[true],
        sortBy:['fecha'],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
    },
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
        { text: 'Fecha', value: 'fecha'},
        { text: 'Tarea', value: 'tarea'},
        { text: 'Respuesta', value: 'respuesta'},
        { text: 'Responsable', value: 'responsable'}
    ],        
    listaGestiones: [], // registros
    selectedRow: []
  }),
  props: ['personaId'],
  watch:{
    'personaId': function(personaId){
        this.loadGestiones(personaId);
    },
    options :{
        handler(){
          this.loadGestiones(this.personaId);
        },
        deep: true
    },
  },
  computed: {  
  },
  created () {
    // if(this.personaId)
    //   this.loadGestiones(this.personaId);
  },
  methods: {
    ...mapMutations(['alertError']),
    ...mapActions(['']),
    async loadGestiones(personaId){
      if(!personaId) return;
      this.loading = true;
      this.emitLoading(true);
      try{
        //tipoGestion 1 -> telefónica
        var result= await http.get('gestion/listgestionesporpersona?personaId='+ personaId + '&tipoGestionId=1' +  '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'true'));

        //Vue.$log.debug(result);

        this.listaGestiones = result.list;
        this.totalItems = result.totalCount;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
      this.emitLoading(false);
    },
    emitLoading (value) {
      this.$emit('loading-changed', value)
    }
},
  
  
}

</script>